import EstadosConexion from './EstadosConexion';
import { BsWifi, BsWifiOff, BsWifi1 } from 'react-icons/bs';
import { formatoMiles } from '../../utils/format';

function statusMeta(estado) {
  switch (estado) {
    case EstadosConexion.Conectado:
      return { className: 'status-ok', icon: <BsWifi />, label: 'Conectado' };
    case EstadosConexion.SinConexion:
      return { className: 'status-down', icon: <BsWifiOff />, label: 'Sin conexión' };
    case EstadosConexion.Alerta:
      return { className: 'status-warn', icon: <BsWifi1 />, label: 'Alerta' };
    default:
      return { className: 'status-ok', icon: <BsWifi />, label: estado };
  }
}

function folioMeta(disponibles, requeridos) {
  if (!requeridos || requeridos <= 0) {
    return { className: 'folio-ok', pct: 100, label: 'Folios suficientes' };
  }
  const ratio = disponibles / requeridos;
  const pct = Math.min(100, Math.round((disponibles / Math.max(requeridos * 1.5, 1)) * 100));
  if (ratio < 1) return { className: 'folio-critical', pct, label: 'Folios insuficientes' };
  if (ratio < 1.1) return { className: 'folio-warning', pct, label: 'Folios bajos' };
  return { className: 'folio-ok', pct, label: 'Folios suficientes' };
}

function EstadoCaja(props) {
  const caja = props.caja;
  const status = statusMeta(caja.estado);
  const folio = folioMeta(caja.folios_disponibles, caja.folios_requeridos);

  return (
    <tr>
      <td className="caja-name">{caja.device_name}</td>
      <td>{status.label}</td>
      <td>
        <div className="folio-cell">
          <span className="folio-text">
            <strong>{formatoMiles(caja.folios_disponibles)}</strong> / {formatoMiles(caja.folios_requeridos)}
          </span>
          <div
            className="folio-bar"
            role="progressbar"
            aria-label={`Folios: ${folio.label}`}
            aria-valuenow={folio.pct}
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuetext={`${formatoMiles(caja.folios_disponibles)} disponibles de ${formatoMiles(caja.folios_requeridos)} requeridos — ${folio.label}`}
          >
            <div className={`folio-bar-fill ${folio.className}`} style={{ width: `${folio.pct}%` }} />
          </div>
        </div>
      </td>
      <td className="text-end folio-last">{formatoMiles(caja.ultimo_folio)}</td>
      <td className="text-center">
        <span
          className={`status-badge ${status.className}`}
          role="img"
          aria-label={status.label}
          title={status.label}
        >
          {status.icon}
        </span>
      </td>
    </tr>
  );
}

export default EstadoCaja;
